import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUserCheck,
    faComment,
    faCalendarCheck
} from "@fortawesome/free-solid-svg-icons";

export default function ActivityFooter({ activity }) {

    if (!activity) return null;

    return (
        <div className="workitem-activity-footer">

            {/* Creator */}
            <span className="footer-item">
                <FontAwesomeIcon icon={faUserCheck} />
                <span className="ms-1">
                    {activity.CreateByName}
                </span>
            </span>

            {/* Comment By */}
            {
                activity.CommentByID &&
                activity.CommentByID !== activity.CreateByID && (
                    <span className="footer-item">
                        <FontAwesomeIcon icon={faComment} />
                        <span className="ms-1">
                            {activity.CommentByName}
                        </span>
                    </span>
                )
            }

            {/* Date */}
            <span className="footer-item">
                <FontAwesomeIcon icon={faCalendarCheck} />
                <span className="ms-1">
                    {activity.PCreationDate}
                </span>
            </span>

        </div>
    );
}